export const MendeleevaData = [
    {
        title: "дом №31",
        year: '1968',
        floor: "2",
        apartment: "10",
        quantityLC: "10",
        livingArea: "409,9",
        notLivinigArea: "нет",
        commonProperty: "39,4",
        type: "многоэтажный жилой дом",
        level: "электроснабжение",
        technicalSupport: "общедомовой прибор учета электроэнергии",
        contractURL: 'mendeleeva/sofrino_mendeleeva_31_dogovor.pdf',
        protocolURL: 'protocol_4_2017-02-16.pdf',
    },

    {
        title: "дом №40",
        year: '1959',
        floor: "2",
        apartment: "8",
        quantityLC: "8",
        livingArea: "390,8",
        notLivinigArea: "нет",
        commonProperty: "41,4",
        type: "многоэтажный жилой дом",
        level: "ХВС,  отопление, канализация, газоснабжение, электроснабжение",
        technicalSupport: "общедомовой прибор учета электроэнергии",
        contractURL: 'mendeleeva/sofrino_mendeleeva_40_dogovor.pdf',
        protocolURL: 'protocol_4_2017-02-16.pdf',
    }

]